const siteInfoFallback = {
  phone: {
    display: '07400663932',
    tel: '+447400663932',
  },
  whatsapp: {
    number: '447400663932',
    defaultMessage: 'Hi, I would like to enquire about a vehicle.',
  },
  address: {
    company: 'JAC Cars Ltd',
    line1: 'Noak Hill Road, Noak Hill Equestrian Centre,',
    line2: 'Romford, Essex, RM3 7LD',
    lines: [
      'JAC Cars Ltd',
      'Noak Hill Road, Noak Hill Equestrian Centre,',
      'Romford, Essex, RM3 7LD',
    ],
  },
  salesHours: [
    { day: 'Monday', hours: '10:00 - 18:00' },
    { day: 'Tuesday', hours: '10:00 - 18:00' },
    { day: 'Wednesday', hours: '10:00 - 18:00' },
    { day: 'Thursday', hours: '10:00 - 18:00' },
    { day: 'Friday', hours: '10:00 - 18:00' },
    { day: 'Saturday', hours: '10:00 - 18:00' },
    { day: 'Sunday', hours: 'By Appt 11:00 - 18:00' },
  ],
  usefulLinks: [
    { href: '#cookie-policy', label: 'Cookie Policy' },
    { href: '#disclaimer', label: 'Disclaimer' },
    { href: '#privacy-policy', label: 'Privacy Policy' },
    { href: '#sitemap', label: 'Sitemap' },
  ],
  partnerLogos: [
    { src: '/footer/zuto.png', alt: 'Zuto' },
    { src: '/footer/close-brothers.png', alt: 'Close Brothers' },
    { src: '/footer/car-finance-247.png', alt: 'Car Finance 247' },
    { src: '/footer/match-me.png', alt: 'match:me' },
    { src: '/footer/warrantywise.png', alt: 'Warrantywise' },
  ],
  aboutUs: {
    heading: 'An Independent Essex Forecourt, Run Properly',
    paragraphs: [
      "For over 15 years we've kept our forecourt stocked with a wide mix of quality used cars — from first-car hatchbacks to family SUVs — sourced, checked and priced fairly, one at a time.",
      "Every car we sell passes a 150-point inspection before it goes on sale. We believe in giving you the full picture up front, not just a car and a handshake.",
    ],
    features: [
      'HPI-Checked Vehicles',
      'Full Vehicle History Reports',
      'Flexible Finance Options',
      '30-Day Money Back Guarantee',
      'Free Vehicle Delivery',
    ],
    imageUrl:
      'https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=800&q=80',
    experienceBadge: {
      number: '15+',
      text: 'Years Trading',
    },
  },
  testimonials: {
    sectionTitle: 'What Our Customers Say',
    sectionSubtitle:
      'Real feedback from buyers who drove away happy',
    items: [
      {
        id: 1,
        text: "Straightforward from start to finish. They talked me through the history on my Ford Focus and there was no pressure to add anything I didn't need. Would buy from them again.",
        authorName: 'James Mitchell',
        authorRole: 'Romford',
        authorInitial: 'J',
      },
      {
        id: 2,
        text: 'No hidden fees, no pressure tactics — just honest service. The finance calculator on the site matched exactly what I was offered in person.',
        authorName: 'Sarah Anderson',
        authorRole: 'Brentwood',
        authorInitial: 'S',
      },
      {
        id: 3,
        text: 'Found a Hyundai Tucson at a fair price, booked a test drive on WhatsApp, and had it delivered two days later. Couldn’t have been easier.',
        authorName: 'Michael Chen',
        authorRole: 'Chelmsford',
        authorInitial: 'M',
      },
    ],
  },
  footer: {
    contactHeading: 'Contact Us',
    salesHeading: 'Sales',
    usefulLinksHeading: 'Useful Links',
  },
};

export default siteInfoFallback;
